import { ITrackingProductPageBaseParameters } from './baseParameters';

export type ITrackingFillVerticalCodeParameters = Pick<
  ITrackingProductPageBaseParameters,
  'productUid'
>;

export const fillVerticalCode = (
  parameters: ITrackingFillVerticalCodeParameters,
) => {
  return {
    vertical_code: parameters.productUid.split('.')[1] ?? '',
  } as const;
};
